export const HOME = '/';
export const PROJECT_DETAIL_FOODSHARER = '/foodsharer';
export const PROJECT_DETAIL_BOOKIO = '/bookio';
export const PROJECT_DETAIL_SHOPISTRY = '/shopistry';
export const PROJECT_DETAIL_HARVEST = '/harvest';
export const PROJECT_DETAIL_CLIMBING = '/climbing-light';
